
<svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Stockholm-icons-/-Shopping-/-Credit-card" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="bound" x="0" y="0" width="24" height="24"></rect>
        <rect id="Combined-Shape" fill="#000000" opacity="0.3" x="2" y="5" width="20" height="14" rx="2"></rect>
        <rect id="Rectangle-59" fill="#000000" x="2" y="8" width="20" height="3"></rect>
        <rect id="Rectangle-59-Copy" fill="#000000" opacity="0.3" x="16" y="14" width="4" height="2" rx="1"></rect>
    </g>
</svg>